import { Box, IconButton } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import CloseIcon from '@mui/icons-material/Close';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { useCallback, useEffect, useState } from 'react';
import { AssetReference, getProtectedAssetUrl } from '@uplift/api';
import { ModalFullPage } from '../../../ModalFullPage';

export type ViewInsuranceModalType = {
  onClose: () => void;
  insuranceCardFront?: string | undefined;
  insuranceCardBack?: string | undefined;
};

export const ViewInsuranceModal: React.VFC<ViewInsuranceModalType> = ({ onClose, insuranceCardFront, insuranceCardBack }) => {
  const [ images, setImages ] = useState<string[] | null>(null);
  const [ imageIndex, setImageIndex ] = useState(0);
  const { classes: modalClasses } = useModalStyles();
  const { classes } = useStyles();

  const getAndSetImages = useCallback(async () => {
    try {
      const front = insuranceCardFront ? await getProtectedAssetUrl(insuranceCardFront, AssetReference.insurance) : undefined;
      const back = insuranceCardBack ? await getProtectedAssetUrl(insuranceCardBack, AssetReference.insurance) : undefined;

      if (front !== undefined && back !== undefined) {
        const stringFront = front || '';
        const stringBack = back || '';

        setImages([ stringFront, stringBack ]);
      } else {
        setImages([]);
      }
    } catch (error) {
      console.error(error);

      setImages([]);
    }
  }, [ insuranceCardFront, insuranceCardBack ]);

  useEffect(() => {
    getAndSetImages();
  }, [ getAndSetImages ]);

  if (!images) return null;

  const imagesLength = images.length;
  const nextImageHandler = () => setImageIndex(p => (p + 1) % imagesLength);
  const prevImageHandler = () => setImageIndex(p => p === 0 ? p : p - 1);
  const showPrev = imageIndex !== 0;
  const showNext = imageIndex !== imagesLength - 1;

  return (
    <ModalFullPage
      open={true}
      classes={modalClasses}
      mobileOnly
      onClose={onClose}
      closeIcon={(
        <IconButton onClick={onClose} className={classes.icon}>
          <CloseIcon />
        </IconButton>
      )}
    >
      <Box display="flex" height="100%">
        <Box width="64px" display="flex" alignItems="center" justifyContent="flex-end">
          {showPrev && (
            <IconButton className={classes.icon} onClick={() => prevImageHandler()}>
              <ChevronLeft fontSize="large" />
            </IconButton>
          )}
        </Box>
        <Box flex={1} display="flex" alignItems="center" justifyContent="center" pt={2} pb={2}>
          <img src={images[imageIndex]} className={classes.image} alt="insurance card" />
        </Box>
        <Box width="64px" display="flex" alignItems="center" justifyContent="flex-start">
          {showNext && (
            <IconButton className={classes.icon} onClick={() => nextImageHandler()}>
              <ChevronRight fontSize="large" />
            </IconButton>
          )}
        </Box>
      </Box>
    </ModalFullPage>
  );
};

const useModalStyles = makeStyles()((theme) => ({
  paper: {
    background: theme.palette.common.black,
    height: '375px'
  },
  paperFullScreen: {
    height: '100%'
  }
}));

const useStyles = makeStyles()((theme) => ({
  icon: {
    color: theme.palette.common.white
  },
  image: {
    maxWidth: '100%',
    maxHeight: '100%',
  }
}));
